import { Link } from "react-router-dom";
import { IoChevronForward } from "react-icons/io5";

const ArtSelectionOption = ({ icon, title, description, onClick, to }) => {
    const content = (
    <>
        <aside className="art-selection-icon">{icon}</aside>
        <article className="art-selection-text">
            <h3>{title}</h3>
            <p>{description}</p>
        </article>
        <aside className="art-selection-chev">
            <IoChevronForward />
        </aside>
    </>
  );

  return to ? (
    <Link to={to} className="art-selection">
      {content}
    </Link>
  ) : (
    <section className="art-selection" onClick={onClick}>
      {content}
    </section>
  );
}

export default ArtSelectionOption